import { Injectable } from '@angular/core';
import { SocketService } from './socket.service';
import { Message } from '../utils/Message';
import { ChangeEvent } from '../events/ChangeEvent';
import { GlobalEventEmitterService } from './global-event-emitter.service';
import { Subscription, Observable, timer, Subject } from 'rxjs';
import { TimeUtils } from '../utils/TimeUtils';
import { AbstractGs } from './AbstractGs';

@Injectable({
  providedIn: 'root'
})
export class BoostService {

  private subjects:Map<string, Subject<string>>;
  private timers:Map<string, Observable<number>>;
  private subscribes:Map<string, Subscription>;
  private timersStarts:Map<string, number>;
  public availables:Map<string, boolean>;
  public timesToEnd:Map<string, string>;
  public cursors:Map<string, string>;

  public getTimeToEnd( boost:string ):string{
    if( this.timesToEnd[ boost ] == undefined ){
      return "";
    }
    return this.timesToEnd[ boost ];
  }

  public setUpBoost( boost:string) : void {
    var enabled:boolean = this.isBoostEnabled( this.gameService.getGameRules(), boost );
    var moreThanZero:boolean = this.count( boost ) > 0;
    var boostFree:boolean = this.isTimerNull(boost);// timers[ boost ] == null;

    if( enabled && moreThanZero && boostFree ){
      this.cursors[boost] = "pointer";
    }else{
      this.cursors[boost] = "auto";
    }
  }

  public stopTimer( boost:string ) :void {
    if( this.timers[ boost ] != null){
      this.subscribes[ boost ].unsubscribe();
      this.timers[ boost ] = null;
      this.setUpBoost( boost );
    }
  }

  public setBoostBlock( boost:string, blocked:boolean ) : void {
    if( !blocked ){
      this.stopTimer( boost );
    }
    this.availables[ boost ] = !blocked;
    if( !blocked ){
      this.subjects[boost].next("-");
    }    
  }

  public isTimerNull(boostName:string):boolean{
    return this.timers[boostName] == null;
  }

  private updateBoostLabel( boost:string, t:number ) : void {
    let time:number = this.getLastingTime( boost ) - ( new Date().getTime() - this.timersStarts[boost]) - t;
    if ( time >= 0 ) {
      let converted:string = TimeUtils.convertTominutesString( time );
      this.timesToEnd[boost] = converted;
      this.subjects[boost].next(converted);
    }
  }

  
  public startBoost( boost:string, time:Number = 0 ):void{
    this.timers[boost] = timer(10, 10);
    this.timersStarts[boost] = new Date().getTime();
    this.subscribes[boost] = this.timers[boost].subscribe( t => {
      this.updateBoostLabel(boost, t);
    });
   // this.setUpBoost( boost );	   //CO Z TYM ??????????????????????????????????????
    this.setBoostBlock( boost, true );
    this.subjects[boost].next("00:00");
  }

  
  public useBoostItem( boost:string ):void {
    if ( this.count( boost ) > 0 && 
    this.isBoostEnabled( this.gameService.getGameRules(), boost ) && 
    this.isTimerNull( boost ) ) {
      this.startBoost( boost );
      let o:any = this.getBoostRelation( boost );
      for ( let rel  in this.getBoostRelation( boost ) ){
        this.startBoost( rel )
      }				
      this.useBoost( boost );
    }
  }

  public subscribe(boost:string, func:Function):Subscription{
    return this.subjects[boost].subscribe( (val) => {
       func.call(val, val); 
    });
  }

  constructor(private gameService:AbstractGs, private socketService:SocketService) {    
    this.boosts = new Map<string, number>();
    this.boostTime = new Map<string, number>();
    this.rlsToBoost = new Map<string, Map<string, string>>();
    this.boostRelation = new Map<string, Map<string, string>>();

    this.timers = new Map<string, Observable<number>>();
    this.timesToEnd = new Map<string, string>();
    this.subscribes = new Map<string, Subscription>();
    this.timersStarts = new Map<string, number>();
    this.availables = new Map<string, boolean>();
    this.cursors = new Map<string, string>();

    this.subjects = new Map<string, Subject<string>>();
    this.subjects[ "HELP" ] = new Subject<string>();
    this.subjects[ "SHUFFLE" ] = new Subject<string>();
    this.subjects[ "ADD_TIME" ] = new Subject<string>();
    this.subjects[ "FREEZE_TIME" ] = new Subject<string>();
    this.subjects[ "POINTS_BOOSTER" ] = new Subject<string>();
    this.subjects[ "ADD_LIFE" ] = new Subject<string>();

    this.availables[ "HELP" ] = true;
    this.availables[ "SHUFFLE" ] = true;
    this.availables[ "ADD_TIME" ] = true;
    this.availables[ "FREEZE_TIME" ] = true;
    this.availables[ "POINTS_BOOSTER" ] = true;
    this.availables[ "ADD_LIFE" ] = true;

    this.availables[ "HELP" ] = true;
    this.availables[ "SHUFFLE" ] = true;
    this.availables[ "ADD_TIME" ] = true;
    this.availables[ "FREEZE_TIME" ] = true;
    this.availables[ "POINTS_BOOSTER" ] = true;
    this.availables[ "ADD_LIFE" ] = true;

    this.setUpBoost( "HELP" );
    this.setUpBoost( "SHUFFLE" );
    this.setUpBoost( "ADD_TIME" );
    this.setUpBoost( "FREEZE_TIME" );
    this.setUpBoost( "POINTS_BOOSTER" );
    this.setUpBoost( "ADD_LIFE" );
  }

   
  public isAvailable( boost:string ):boolean{
    if( this.availables[boost] == undefined ){
      return true;
    }
    return this.availables[ boost ];
  }

  private boosts:Map<string, number>;
  
  private boostTime:Map<string, number>;
  
  private boostRelation:Map<string, Map<string, string>>;
  
  private rlsToBoost:Map<string, Map<string, string>>;
  
  public getLastingTime( boost:string ) : number {
    return this.boostTime[ boost ] * 50;
  }
  
  public setBoostSettings( settings:Array<any> ) : void {
    let pos:number = 0; 
    let timeSize:number = parseInt( settings[ pos++ ] );
    for ( let i:number = 0; i < timeSize; i++ ) {
      this.boostTime[ settings[ pos++ ] ] = settings[ pos++ ]; 
    }
    
    let size:number = parseInt( settings[ pos++ ] );
    for (let i = 0; i < size; i++ ) {
      var rls:string = settings[ pos++ ];
      var boost:string = settings[ pos++ ];
      if ( this.rlsToBoost[ rls ] == null ) {
        this.rlsToBoost[ rls ] = new Map<string, string>();
      }
      this.rlsToBoost[ rls ][ boost ] = boost;
    }
    
    size = parseInt( settings[ pos++ ] );
    for (let i = 0 ; i < size; i++ ) {
      let boostName:string = settings[ pos++ ];
      let boostSize:number = settings[ pos++ ];
      this.boostRelation[ boostName ] = new Map<string, string>();
      
      for ( let j:number = 0; j < boostSize; j++ ) {
        let boostRel:String = settings[ pos++ ];
        this.boostRelation[ boostName ][ boostRel ] = boostRel;
      }
    }
  }
  
  public getBoostRelation( boost:string ) : Map<string, string>{
    return this.boostRelation[ boost ];
  }
  
  public isBoostEnabled( rls:string, boost:string ) : boolean {
    return this.rlsToBoost[ rls ] != null && this.rlsToBoost[ rls ][ boost ] != null;
  }
  
  
  public max( boost:string ) : boolean{
    return this.boosts[ boost ] != null && this.boosts[ boost ] >= 10;
  }
  
  public count( boost:string ) : number{
    return this.boosts[ boost ] == null ? 0 : this.boosts[ boost ];
  }
  
  public addBoost( type:string ) : void {
    if ( this.boosts[ type ] == null ) {
      this.boosts[ type ] = 1;
    }else{
      this.boosts[ type ]++;
    }
    this.setUpBoost( type );
  }
  
  public removeBoost( type:string ) : void {
    if ( this.boosts[ type ] == null ) {
      throw new Error( "No Boost to remove" + type );
    }else{
      this.boosts[ type ]--;
    }
    this.setUpBoost( type );
  }
  
  public setBoosts( boosts:Array<string> ) :void {
    let size:number = parseInt( boosts[ 0 ] );
    let i:number = 1;
    for ( var j:number = 0; j < size; j++ ){
      var type:string = boosts[ i++ ];
      var quantity:number = parseInt( boosts[ i++ ] );
      this.boosts[ type ] = quantity;
      this.setUpBoost( type );
    }
  }
  
  public useBoost( boost:string ) : void {
    this.boostAction( boost );
    var msg:Message = new Message();
    msg.fromServer = false;
    msg.params = new Array();
    msg.params[ 0 ] = boost;
    msg.receiver = "server";
    msg.sender = this.gameService.user.getCurrentUser();
    msg.name = "useBoost";
    
    this.socketService.sendMsg( msg );
  }
  
  public stopBoostEffect( boost:string ) : void {
    let msg:Message = null;
    switch ( boost ) {
      case "HELP":
        break;
      case "SHUFFLE":
        break;
      case "FREEZE_TIME":
        msg = new Message();
        msg.name = "freezeTime";
        msg.params = new Array();
        msg.params[ 0 ] = "false";
        GlobalEventEmitterService.globalEmitter.emit( new ChangeEvent( "changeEvent", msg ) );
        break;
    }
  }
  public boostAction( boost:String ) : void {
    var msg:Message = null;
    switch ( boost ) {
      case "HELP":
        msg = new Message();
        msg.name = "getHelp";
        GlobalEventEmitterService.globalEmitter.emit( new ChangeEvent( "changeEvent", msg ) ); 
        break;
      case "SHUFFLE":
        msg = new Message();
        msg.name = "shuffle";
        GlobalEventEmitterService.globalEmitter.emit( new ChangeEvent( "changeEvent", msg ) ); 
        break;
      case "FREEZE_TIME":
        msg = new Message();
        msg.name = "freezeTime";
        msg.params = new Array();
        msg.params[ 0 ] = "true";
        GlobalEventEmitterService.globalEmitter.emit( new ChangeEvent( "changeEvent", msg ) ); 
        break;
    }
  }
}